import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { AdminService } from '../../services/admin.service';
import { loadAnalyticReports, loadAnalyticReportsSuccess, loadUserRoles, loadUserRolesSuccess } from '../actions/admin.actions';

@Injectable()
export class AdminEffects {

  constructor(private actions: Actions, private adminService: AdminService) { }

  loadUserRoles = createEffect(() => {
    return this.actions.pipe(
      ofType(loadUserRoles),
      distinctUntilChanged(),
      switchMap(() => this.adminService.getUserRoles()),
      map((userRoles) => loadUserRolesSuccess({ payload: userRoles }))
    );
  });

  loadAnalyticReports = createEffect(() => {
    return this.actions.pipe(
      ofType(loadAnalyticReports),
      distinctUntilChanged(),
      switchMap(() => this.adminService.getAnalyticReports()),
      map((analyticReports) => loadAnalyticReportsSuccess({ payload: analyticReports }))
    );
  });
}
